































































































































































































declare const google
import Vue from 'vue'
import moment from 'moment'

import GoogleMap from '@/components/app/GoogleMap.vue'
import ImageViewer from '@/pages/Viewer.vue'
import VideoViewer from '@/pages/Video.vue'
import VideoList from '@/components/video/VideoList.vue'
import Axios from 'axios'

export default Vue.extend({
  components: { GoogleMap, ImageViewer, VideoList, VideoViewer },
  props: {
    
  },
  data() {
    return {
      activeViewer: "",
      loading: true,
      infoWindowOpen: false,
      maps: [] as any[],
      mapViews: [] as any[],
      noneFilteredMapViews: [] as any[],
      views: [] as any[],
      selected: {
        map: null as string | null,
        view: null as string | null
      },
      showMap: false,
      showVideoList: false,
      stage: 0,
      secondaryFilter: '0' as string,
      search: '' as string,
      availableSecondaryFilters: [] as string[],
      videoId: null as string | null,
      viewerLoading: true
    }
  },
  computed: {
    displayViews():{my: any[], other: any[]} {
      if (this.selected.map) {
        return {
          my: this.views.filter(view => {
            return this.mapViews.findIndex(mapView => mapView._id == view._id) > -1
          }),
          other: this.mapViews.filter(mapView => this.views.findIndex(view => view._id == mapView._id) === -1)
        }
      } else {
        return {
          my: this.views,
          other: []
        }
      }
    },

    map():any {
      const mapData = this.maps.find(map => map._id == this.selected.map)
      let map = {
        _id: "",
        center: {
          lat: 0,
          lng: 0
        },
        title: "Map",
        zoom: 1
      }
      if (mapData) {
        map = {
          _id: mapData._id,
          center: {
            lat: mapData.latitude,
            lng: mapData.longitude
          },
          title: mapData.name,
          zoom: mapData.zoom
        }
      }
      return map
    },
    markers():any[] {
      const markers = [] as any[]
      const mapData = this.maps.find(map => map._id == this.selected.map)
      const mapIcon = mapData.icon == null ? "" : mapData.icon 
      this.mapViews.forEach(mapView => {
        const index = this.views.findIndex(view => view._id == mapView._id)
        const active = mapView._id == this.selected.view
        const marker = {
          _id: mapView._id,          
          icon: mapIcon,
          position: {
            lat: mapView.latitude,
            lng: mapView.longitude
          },
          title: mapView.name
        }
        markers.push(marker)
      })
      return markers
    }
  },
  methods: {
    closeViewer() {
      this.activeViewer = ''
      history.go(-1)
    },
    searchInput(search: string) {     
      if (search.length > 0) {
        const words = search.toLowerCase().split(";");
        const items = this.noneFilteredMapViews.filter((item) => {
          return words.every(
            (string) =>
              JSON.stringify(Object.values(item))
                .toLowerCase()
                .indexOf(string.trim()) > -1
          );
        });
        this.mapViews = items;
      }
      else{
        this.mapViews = this.noneFilteredMapViews;
      }
    },
    async getMaps() {
      try {
        const query = await this.newQuery("maps")
        query.orderBy('name').get().then(snapshot => {
          const maps = [] as any[]
          snapshot.forEach(doc => {
            maps.push({_id: doc.id, ...doc.data()})
          })
          this.maps = maps
          if (!this.selected.map && maps.length) {
            const id = maps[0]._id
            this.selected.map = id
            this.getMapViews(id)
          } else {
            this.getMapViews()
          }
        }, err => {
          throw err
        })
      } catch (err) {
        if (err.code === "unavailable") {
              alert("Unable to connect to the database due to a poor internet connection. You may wait for the connection to be restored, or try refreshing the page.")
            }
            window.console.error(err)
      }
    },
    async getMapViews(mapId?) {
      if (mapId) {
        try {
            this.$db.collection("maps").doc(mapId).collection("views").orderBy('name').get().then(snapshot => {
              const secondaryFilters = [] as string[];
              const views = [] as any[]
              snapshot.forEach(doc => {
                const data = doc.data();
                
                if(data.secondaryFilter != undefined && data.secondaryFilter != '' && secondaryFilters.includes(data.secondaryFilter) == false){
                  secondaryFilters.push(data.secondaryFilter);
                }
                views.push({_id: doc.id, ...data})
              })
              
              this.mapViews = views.filter(view => this.stage == 0 || view.stage == this.stage)
              this.availableSecondaryFilters = secondaryFilters;
              if(this.availableSecondaryFilters.includes(this.secondaryFilter) == false)
              {
                this.secondaryFilter = '0';
              }
              this.mapViews = this.mapViews.filter(view => this.secondaryFilter == '0' || view.secondaryFilter == this.secondaryFilter)
              this.noneFilteredMapViews = this.mapViews;
              this.searchInput(this.search);
              this.loading = false
            }, err => {
              throw err
            })
          } catch (err) {
            if (err.code === "unavailable") {
              alert("Unable to connect to the database due to a poor internet connection. You may wait for the connection to be restored, or try refreshing the page.")
            }
            window.console.error(err)
          }
        } else {
        this.mapViews = [] as any[]
        this.loading=false
      }
    },
    async getViews() {
      try {
        const query = await this.newQuery("views")
        query.get().then(snapshot => {
          let views = [] as any[]
          snapshot.forEach(doc => {
            views.push({_id: doc.id, ...doc.data()})
          })
          views = this.sort(views, ["name"])
          const live = views.filter(view => view.stage === 2)
          const pending = views.filter(view => view.stage === 1)
          const completed = views.filter(view => view.stage === 3)
          views = live.concat(completed)
          views = views.concat(pending)
          this.views = views
        })
      } catch (err) {
        if (err.message.indexOf("offline") > -1) {
          alert("Unable to connect to the database due to a poor internet connection. You may wait for the connection to be restored, or try refreshing the page.")
        }
        window.console.error(err)
      }
    },
    loadViewer(id) {
      if (id) {
        this.viewerLoading = true
        this.activeViewer = id
        history.pushState({}, document.title, this.$route.path + '?viewer=' + id)
      } else {
        this.viewerLoading = false
        this.activeViewer = ''
      }
    },
    selectMarker(marker, index) {
      this.showMap = !this.showMap
      const map = this.maps.find(map => map._id == this.selected.map)
      map.latitude = marker.position.lat
      map.longitude = marker.position.lng
      map.zoom = 16
      this.$set(this.maps, this.maps.findIndex(map => map._id == this.selected.map), map)
      
      this.selected.view = marker._id
      this.focusView(marker._id)
      
    },
    async showVideo(id) {
      this.videoId = id
    },
    loadVideoList(view) {
      this.selected.view = view._id
      this.showVideoList = true
    },
    async newQuery(collection):Promise<firebase.firestore.Query> {
      const user = await (() => {
        return new Promise((resolve, reject) => {
          this.$auth.onAuthStateChanged(user => {
            if (user) {
              resolve(user)
            } else {
              reject("User not authenticated")
            }
          })
        })
      })()
      if (user) {
        let ref = this.$db.collection(collection)
        let query:firebase.firestore.Query
        if (this.$store.state.auth.token.claims.super) {
          query = ref
        } else if (this.$store.state.auth.token.claims.partner) {
          query = ref.where('partners', 'array-contains', this.$store.state.auth.token.claims.partner)
        } else if (this.$store.state.auth.token.claims.client) {
          query = ref.where('clients', 'array-contains', this.$store.state.auth.token.claims.client)
        } else {
          query = ref.where('users', 'array-contains', this.$store.state.auth.token.claims.user_id)
        }
        return query
      }
      throw new Error("User not authenticated.")
    },
    sort(items, fields) {
      return this.$schema.sort(items, fields)
    },
    focusView(id) {
      const viewList = document.getElementById("views-list-wrapper")
      const viewItem = document.getElementById("item-"+id)

      if (viewList && viewItem) {
        viewList.scrollTop = viewItem.offsetTop - 10
      }
    },
    windowAlert(message) {
      alert(message)
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format("ddd DD MMM YYYY - HH:mm")
    }
  },
  created() {
    this.getMaps()
    this.getViews()
  },
  mounted() {
    window.addEventListener('popstate', e => {
      const search = window.location.search
      if (search.indexOf('viewer') > -1) {
        const params = new URLSearchParams(search)
        this.viewerLoading = true
        this.activeViewer = params.get('viewer') || ''
      } else {
        this.loadViewer(null)
      }
    })
  },
  updated() {

  }
})
